 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~0e8f512f":"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~0e8f512f","admin-add-users":"admin-add-users","admin-group-form~company-form":"admin-group-form~company-form","admin-group-form":"admin-group-form","company-form":"company-form","admin-groups":"admin-groups","admin-users":"admin-users","challenge-detail":"challenge-detail","challenge-form":"challenge-form","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event":"challenges~company~edit-event~event-checkin~events-company-tab~group~new-event","challenges":"challenges","company~events-company-tab~group~new-event":"company~events-company-tab~group~new-event","company~group":"company~group","company":"company","group":"group","event-details~new-event":"event-details~new-event","new-event":"new-event","edit-event":"edit-event","companies":"companies","edit-users":"edit-users","events-company":"events-company","interest":"interest","kynd-points-index":"kynd-points-index","product-features":"product-features","profile":"profile","widgets":"widgets","events-company-tab":"events-company-tab","event-checkin":"event-checkin","create-password":"create-password","event-details":"event-details","event-settings":"event-settings","login":"login"}[chunkId]||chunkId) + "-legacy." + {"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~0e8f512f":"facebb07","admin-add-users":"bda66579","admin-group-form~company-form":"2bccb1a1","admin-group-form":"e5db5f55","company-form":"ad1c3e21","admin-groups":"5f335fb1","admin-users":"15038ac3","challenge-detail":"2e9a7145","challenge-form":"dd383089","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event":"fdd31512","challenges":"c7dcbd3f","company~events-company-tab~group~new-event":"93c08a57","company~group":"e6d5c1ed","company":"aaa90897","group":"3cbcdcb3","event-details~new-event":"0d6fa3bd","new-event":"92dcb073","edit-event":"cd5f8f55","companies":"6f3afef5","edit-users":"08c856d2","events-company":"b03804cb","interest":"6b4b60c0","kynd-points-index":"7a4b634f","product-features":"4d57b4f6","profile":"7cf461d6","widgets":"67989872","events-company-tab":"a4180c6f","event-checkin":"d2f0e8a3","create-password":"cab9cf6e","event-details":"addbb508","event-settings":"16c7646e","login":"ab40bf0d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-group-form":1,"company-form":1,"challenge-detail":1,"challenge-form":1,"company~events-company-tab~group~new-event":1,"company~group":1,"event-details~new-event":1,"events-company":1,"profile":1,"widgets":1,"event-checkin":1,"event-settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~0e8f512f":"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~0e8f512f","admin-add-users":"admin-add-users","admin-group-form~company-form":"admin-group-form~company-form","admin-group-form":"admin-group-form","company-form":"company-form","admin-groups":"admin-groups","admin-users":"admin-users","challenge-detail":"challenge-detail","challenge-form":"challenge-form","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event":"challenges~company~edit-event~event-checkin~events-company-tab~group~new-event","challenges":"challenges","company~events-company-tab~group~new-event":"company~events-company-tab~group~new-event","company~group":"company~group","company":"company","group":"group","event-details~new-event":"event-details~new-event","new-event":"new-event","edit-event":"edit-event","companies":"companies","edit-users":"edit-users","events-company":"events-company","interest":"interest","kynd-points-index":"kynd-points-index","product-features":"product-features","profile":"profile","widgets":"widgets","events-company-tab":"events-company-tab","event-checkin":"event-checkin","create-password":"create-password","event-details":"event-details","event-settings":"event-settings","login":"login"}[chunkId]||chunkId) + "." + {"admin-add-users~admin-group-form~admin-groups~admin-users~challenge-detail~challenge-form~challenges~0e8f512f":"31d6cfe0","admin-add-users":"31d6cfe0","admin-group-form~company-form":"31d6cfe0","admin-group-form":"316afcb6","company-form":"7c475182","admin-groups":"31d6cfe0","admin-users":"31d6cfe0","challenge-detail":"1ee31386","challenge-form":"a070033f","challenges~company~edit-event~event-checkin~events-company-tab~group~new-event":"31d6cfe0","challenges":"31d6cfe0","company~events-company-tab~group~new-event":"dcbb1972","company~group":"8d8ab832","company":"31d6cfe0","group":"31d6cfe0","event-details~new-event":"2e108562","new-event":"31d6cfe0","edit-event":"31d6cfe0","companies":"31d6cfe0","edit-users":"31d6cfe0","events-company":"79db26b9","interest":"31d6cfe0","kynd-points-index":"31d6cfe0","product-features":"31d6cfe0","profile":"d45c3f7c","widgets":"565efa65","events-company-tab":"31d6cfe0","event-checkin":"d21a5eab","create-password":"31d6cfe0","event-details":"31d6cfe0","event-settings":"bc2b43ca","login":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
